import React from 'react';
import store from '../store';
import { slugify,YesNoList,s2ab,insert_rows} from '../config/static';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions  from '@material-ui/core/DialogActions';
import DialogContent  from '@material-ui/core/DialogContent';
import DialogTitle  from '@material-ui/core/DialogTitle';
import ReactPlayer from "react-player";
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid';
import LocationOnIcon from '@material-ui/icons//LocationOn';
import EditIcon from '@material-ui/icons//Edit';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import Typography from '@material-ui/core/Typography';
import firebase from "firebase/app";
import "firebase/firestore";
import SaveIcon from '@material-ui/icons/Save';
import DeleteIcon from '@material-ui/icons/Delete';
import CloseIcon from '@material-ui/icons/Close';
import Divider from '@material-ui/core/Divider';
import ImageIcon from '@material-ui/icons/Image';
import AllInboxIcon from '@material-ui/icons/AllInbox';
import Dropzone from "react-dropzone";
import { NotificationManager} from 'react-notifications';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import Chip from '@material-ui/core/Chip';
import Avatar from '@material-ui/core/Avatar';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import * as STATIC from '../config/static';
import * as LHELPER from './LessonHelper';
import _ from 'lodash';
import { CSVLink, CSVDownload } from "react-csv";
import XLSX from 'xlsx';
import moment from 'moment';
import CircularProgress  from '@material-ui/core/CircularProgress';
var FileSaver = require('file-saver');
// const csvData = [
//   ["firstname", "lastname", "email"],
//   ["Ahmed", "Tomi", "ah@smthing.co.com"],
//   ["Raed", "Labes", "rl@smthing.co.com"],
//   ["Yezzi", "Min l3b", "ymin@cocococo.com"]
// ];
function generateSearch(item){
  let arr = slugify(item.ten).split('-');
  arr.push(slugify(item.ten).replace(/\-/gi, " "));
  arr.push(item.id.toLowerCase());
  return arr;
}
function generatePassword(length) {
    var result           = '';
    var characters       = '0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() *
 charactersLength));
   }
   return result;
}

const styles = theme => ({
  container: {
    flexGrow: 1,
    position: 'relative',
    marginRight: 'auto',
    marginLeft: 'auto',
    width: '90%'
  },search: {
      backgroundColor: '#fff',
      padding: theme.spacing.unit,
      paddingLeft: theme.spacing.unit * 2,
      borderRight: 'solid 1px #ededed',
      borderLeft: 'solid 1px #ededed',
      borderTop: 'solid 1px #ededed'
  },
  textField: {
    minWidth: 200
  },
  input: {
    display: 'none',
  },group_list:{
    border:"1px solid gray",
    display:'flex',
    flexDirection:'column'
  },
  group_list_item:{
    textAlign:'center',
    border:"1px solid gray",
    padding:5,
    display:'flex',
    flexDirection:'column',
    justifyContent:'center',
    alignItems:'center',
    wordBreak:'break-word'
  }
  ,
  group_list_input:{
    textAlign:'center',
    border:"none",
    background:'transparent',
    width: '100%',
    height: '100%',
  },
});
function searchLabel(array,value)
{
  let rel='';
  let index = array.findIndex(a=>a.value==value);
  if(index>-1)
  {
    rel = array[index].label;
  }
  return rel;
}
var _this;


class CreateDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      item: _.cloneDeep(props.item),
      agents:[],
      open: false,
      curSetIndex:0,
      curWeek:null,
      curDay:null,
      curDayIndex:null,
      csvData:[],
      downloadCSV:false,
      results:[],
      curLevelIndex:-1,
      agentIndex:"All",
      import_type:"All",
      loading:false,
    }
    _this = this;
  }
  componentDidMount(props)
  {
    this.loadAgents();
  }
  async loadAgents()
  {
    let agents = [];
      let data = await firebase.firestore().collection("data_agents").where("enable","==",1).get();

      if(data.size>0)
      {
        data.forEach(d=>{
          let i = d.data();
          agents.push(i);
        })
      }
      _this.setState({agents});
  }

export(item)
{
  if(item.type.length==0)
  return;
  let questions =  LHELPER.randomQuestionList(item.qCount,item);
//  console.log(questions);
  let headers = [];
  let headers2 = [];
  let csvData = [];
  let data = [];
  let results = [];
  let spaces = [];
  for(let n=0;n<item.rows;n++){
    data[n]=[];
  }
  for(let r=0;r<item.qCount;r++)
  {
    headers.push('C'+(r+1));
    let q = questions[r];
    for(let n=0;n<item.rows;n++){
      data[n].push(q.numbers[n]);
    }
    results.push(q.result);
    spaces.push("");
    headers2.push(q.type);
  }
csvData.push(headers);
  csvData.push(headers2);
  for(let n=0;n<item.rows;n++){
    csvData.push(data[n]);
  }
  csvData.push(spaces);
  csvData.push(results);
  _this.setState({csvData,downloadCSV:true});
}
showDownload(csvData){
  setTimeout(()=>{
    _this.setState({downloadCSV:false});
  },2000)
  return <CSVDownload data={csvData} target="_blank" />;
}



  handleChange = name => event => {
    event.preventDefault();
    const item = _this.state.item;

    item[name] = event.target.value;

    _this.setState({ item });
  }
  handleSettingChange = name => event => {
    event.preventDefault();
    const { part,curSetIndex } = this.state;
    let curDay = part.sets[curSetIndex].config;
    curDay[name] = event.target.value;

    _this.forceUpdate();
  }
  handleDelete = (name,value) => {
    const { item,curDayIndex,curWeekIndex } = this.state;
    let curDay =  item;
      let change = curDay[name];

      change = _.without(change,value);
      curDay[name] = change;

      this.setState({
          item
      });
  }


async  CreateItem  (data) {

    const item = data;

    //var check = window.confirm("Do you want to add category?");
    var _this=this;

          var docRef = firebase.firestore().collection("courses").doc();

            docRef.set(item)
              .then(function () {
                item.id = docRef.id;
              //  item.order = item.order?parseInt(item.order):0;
                console.log(item);
                  //store.dispatch({ type: 'CREATE_DISTRICT', item });
                NotificationManager.success("Success!");
                _this.forceUpdate();
              //  _this.setState(RESET_CITY);
                //_this.props.onClose();
              })
              .catch(function (error) {
                console.error(error);
              });






  }

  async SaveItem  (data)  {
    //event.preventDefault();
    const item = data;

    var _this=this;

      const id = item.id;

      firebase.firestore().collection("courses").doc(id).update(item)
        .then(function () {
          item.id = id;
          //item.order = item.order?parseInt(item.order):0;
          //let index = store.getState().CITIES.findIndex(e => e.id === id);
          //store.dispatch({ type: 'UPDATE_DISTRICT', item, index });
          NotificationManager.success("Success!");
        //  _this.setState(RESET_CITY);
          _this.forceUpdate();
        })
        .catch(function (error) {
          console.error(error);
        });

  }
  DeleteItem = (id) => event => {
    var check = window.confirm("Do you want to delete this category?");
    var _this=this;
    if (check === true) {
        firebase.firestore().collection("categories").doc(id).delete().then(()=>{
            NotificationManager.success("Success!");
            _this.props.onClose();
        });
    }

  }
  handleClose = () => event => {
    event.preventDefault();
    //this.setState(RESET_CITY);
    this.props.onClose();
  };
  handleChangeWeek = event=>{
    event.preventDefault();

    this.setState({curWeekIndex:event.target.value,curDayIndex:null})
  }


checkMultiOrDivide(type){

  for(let t of type)
  {
    if(t=="multiple"||t=='divide')
    return true;
  }
  return false;
}
checkDivide(type){

  for(let t of type)
  {
    if(t=='divide')
    return true;
  }
  return false;
}
onItemChange = (value,item,key)=>{
  item[key]=value;
  if(key=="active")
  {
    //console.log('Update')
    firebase.firestore().collection('competitors').doc(item.id).update({active:value});
  }
  this.forceUpdate();
}
async findItems(){
  const { search,item } = this.state;
  if(!search||search.trim().length<2)
  {
      return NotificationManager.error("Hãy nhập ít nhất 2 ký tự!");
  }
  let arr = slugify(search).split('-');
  let data = await firebase.firestore().collection("competitors").where("comp_id","==",item.comp_id).where("search","array-contains-any",arr).get();
  let results = [];
  if(data.size>0)
  {
    data.forEach((doc)=>{
      let i = doc.data();
      i.id = doc.id;
      results.push(i);
    })
  }
  //console.log(results);
    _this.setState( {results});
}
async loadResults(){
  const { curLevelIndex,item,agentIndex,import_type } = this.state;
  let docRef = firebase.firestore().collection("competitors").where("comp_id","==",item.comp_id);
  if(curLevelIndex!=-1)
  docRef = docRef.where("level","==",curLevelIndex);
  if(agentIndex!="All")
  docRef = docRef.where("ma_cs","==",agentIndex);
  if(import_type!="All")
  docRef = docRef.where("import_type","==",import_type);
  let data = await docRef.get();
  let results = [];
  if(data.size>0)
  {
    data.forEach((doc)=>{
      let i = doc.data();
      i.id = doc.id;
      results.push(i);
    })
  }
  //console.log(results);
    _this.setState( {results});
}
async onUpload(e) {
  const { item } = this.state;
  let file = e.target.files[0];
  console.log(file);
  let id = 0;
  var reader = new FileReader();
  reader.onload = (evt) => { // evt = on_file_select event
  /* Parse data */
  const bstr = evt.target.result;
  const wb = XLSX.read(bstr, {type:'binary'});
  /* Get first worksheet */
  const wsname = wb.SheetNames[0];
  const ws = wb.Sheets[wsname];
  let cRow = 2;
  let newObject = {};
  let data = [];
  for(let z in ws)
  {
    if(z[0] === '!') continue;
    var tt = 0;
      for (var i = 0; i < z.length; i++) {
          if (!isNaN(z[i])) {
              tt = i;
              break;
          }
      };
      var col = z.substring(0,tt);
      var row = parseInt(z.substring(tt));
      var value = ws[z].v;
      if(row == 1 && value) {

          continue;
      }
      if(cRow!=row)
      {

        data.push(_.cloneDeep(newObject));
        newObject = {};
        cRow=row;
      }
      if(col=='A')
      {
        newObject['comp_id']=value;
        newObject['import_type'] = "Excel";
      }
      if(col=='B')
      {
        newObject['ten']=value;
      }
      if(col=='C')
      {
        newObject['username']=value.toUpperCase();
        if(!newObject['username']||newObject['username'].trim().length==0)
        {

        }
        else
        newObject['id']=value.toUpperCase();
        newObject.active=1;
      }
      if(col=='D')
      {
        newObject['password']=value.toString();
        //console.log("Password",newObject['password'])
        if(!newObject['password']||newObject['password'].trim().length==0)
        {

          newObject['password']=generatePassword(6);
          //console.log("Generate Password",newObject['password'])
        }

      }
      if(col=='E')
      {

        if(value.length!=10)
        {
          let timestamp = (Number(value) - 25569) * 86400*1000;

          newObject['ngay_sinh']=moment(timestamp).valueOf();
        }
        else {
          newObject['ngay_sinh']=moment(value,"DD/MM/YYYY").valueOf();
        }


        //let age = moment(this.state.item.end_date).diff(moment(newObject['ngay_sinh']),"years");
        let age = moment().year() - 1 - moment(newObject['ngay_sinh']).year();
        let levelIndex = 0;
        for(let level of _this.state.item.levels)
        {
          //console.log(age,parseInt(level.age),parseInt(level.toage))
          if(parseInt(level.age)<=age&&parseInt(level.toage)>=age)
          {
            //console.log(levelIndex);
            break;
          }
          levelIndex++;
        }
        newObject['level'] = levelIndex;
      }
      if(col=='F')
      {
        newObject['ma_cs']=value;
      }
      if(col=='G')
      {
        newObject['sdt']=value;
        if((!newObject['id']||newObject['id'].trim().length==0)&&newObject['sdt']&&newObject['ten'])
        {
          let arr = slugify(newObject['ten']).split('-');
          let username = arr[arr.length-1]+value;
          newObject['username']=username.toUpperCase();
          newObject['id']=username.toUpperCase();
        }

      }
      if(col=='H')
      {
        newObject['email']=value;
      }
      if(col=='I')
      {
        newObject['image']=value;
        if(value&&value.length>0)
        {
          let t = value.split("file/d/");

          if(t.length>1)
          {
            t = t[1].split("/");
            newObject['image']="https://drive.google.com/uc?export=view&id="+t[0];
          }
        }
      }
      if(col=='J')
      {
        newObject['active']=parseInt(value.toString());
      }
  }
  if(Object.keys(newObject).length>0)
  data.push(_.cloneDeep(newObject));
   console.log(data);
  // return;
  if(data&&data.length>0)
  {
     _this.importData(data);
  }
  _this.uploadRef.value="";
}

reader.readAsBinaryString(file);
}
async removeComp(comp,index) {
  console.log(index)
  var check = window.confirm("Bạn có muốn xoá thí sinh "+comp.ten+"?");
  if(check)
  {
    firebase.firestore().collection('competitors').doc(comp.id).delete();
    _this.state.results.splice(index,1)
    _this.forceUpdate();
  }
}
async clearAll() {
  var check = window.confirm("Bạn có muốn xoá tất cả thí sinh ?");
  if(check)
  {
    const { curLevelIndex,item } = this.state;
    let docRef = firebase.firestore().collection("competitors").where("comp_id","==",item.comp_id);

    let data = await docRef.get();
    let results = [];
    if(data.size>0)
    {
      data.forEach((doc)=>{
        let i = doc.data();
        i.id = doc.id;
        results.push(i);
      })
    }
    let batch = firebase.firestore().batch();
  				let count = 0;
  				for(let i of results)
  				{
  					const ref = firebase.firestore().collection('competitors').doc(i.id);

            batch.delete(ref);
  					count++;
  					if(count>400)
  					{
  						await batch.commit();
  						batch = firebase.firestore().batch();
  						count=0;
  					}
  				}
          await batch.commit();
          _this.setState({results:[]})
  }
}
async loadListFromAPI(){
  if(this.state.loading)
  {
    return;
  }
  await this.setState({loading:true});
  let rel = await STATIC.loadJSONData(STATIC.API_COMP_FETCHLIST);
  if(rel&&rel.status==1)
  {
    let data = [];
    for(let item of rel.data)
    {
      
      let newObject = {comp_id:this.state.item.comp_id,ten:item.ten,username:item.userLog.toUpperCase(),password:item.matkhau,ma_cs:""};
      newObject['sdt'] = item.PHHS_dienthoai;
      newObject['email'] = item.email;
      newObject['active']=parseInt(item.enable);
      newObject['import_type'] = "API";
      if(!newObject['password']||newObject['password'].trim().length==0)
        {

          newObject['password']=generatePassword(6);
          //console.log("Generate Password",newObject['password'])
        }
        if(!newObject['username']||newObject['username'].trim().length==0)
        {
          if(newObject['sdt']&&newObject['ten'])
          {
            let arr = slugify(newObject['ten']).split('-');
            let username = arr[arr.length-1]+newObject['sdt'];
            newObject['username']=username.toUpperCase();
            newObject['id']=username.toUpperCase();
          }
        }
        else
        newObject['id']=newObject['username'].toUpperCase();
      newObject['ngay_sinh']=moment(item.namsinh).valueOf();
      //let age = moment(this.state.item.end_date).diff(moment(newObject['ngay_sinh']),"years");
      let age = moment().year() - 1 - moment(newObject['ngay_sinh']).year();
        let levelIndex = 0;
        for(let level of _this.state.item.levels)
        {
          //console.log(age,parseInt(level.age),parseInt(level.toage))
          if(parseInt(level.age)<=age&&parseInt(level.toage)>=age)
          {
            //console.log(levelIndex);
            break;
          }
          levelIndex++;
        }
        newObject['level'] = levelIndex;
        let cs = _this.state.agents.find(f=>f.id==item.idChiNhanh);
        if(cs)
        {
          newObject['ma_cs'] = cs.machinhanh;
        }
        newObject['image']="https://superbrain.com.vn"+item.imageupload;
        data.push(newObject);

    }
    if(data&&data.length>0)
    {
      _this.importData(data);
    }

    //NotificationManager.success("Đã thêm "+data.length);
  }
  await this.setState({loading:false});
  
}
async importData(data)
{
  let agents = _this.state.agents;


  let batch = firebase.firestore().batch();
				let count = 0;
				for(let i of data)
				{
          if(!i.id||i.id.length==0)
          continue;
          let cs = agents.find(f=>f.machinhanh==i.ma_cs);
          let ten_cs = "";
          if(cs)
          {
            ten_cs=cs.ten;
          }
					const ref = firebase.firestore().collection('competitors').doc(i.id);
          let search = generateSearch(i);
          batch.set(ref, {...i,search,ten_cs,updated:(new Date().getTime())}, { merge: true });
					count++;
					if(count>400)
					{
						await batch.commit();
						batch = firebase.firestore().batch();
						count=0;
					}
				}
        await batch.commit();
        NotificationManager.success("Đã thêm "+data.length);
}
async exportExcel() {
  var wb = XLSX.utils.book_new();
  wb.Props = {Title: "Danh sách thí sinh"};
        // wb.SheetNames.push("Sheet 1");
        // const ws = wb.Sheets["Sheet 1"];
        let data = _this.state.results;
        let row = 2;
        let count = 1;
        let ws_data = [["Tên đăng nhập","Tên","Mật khẩu","Ngày Sinh","Quê Quán","Mã cuộc thi","Cấp độ","Kích hoạt","Đã thêm từ"]]

        for(let i of data)
        {



          // ws['A'+row].v = count;
          // ws['B'+row].v = d.created_name;
          // ws['E'+row].v = moment(d.created_date).format("DD/MM/YYYY");
          // ws['F'+row].v = d.project;
          // ws['G'+row].v = code;
          // ws['H'+row].v = name;
          // ws["H4"].v = SL;
          // ws['J'+row].v = SL_Complete;
          ws_data.push([i.username,i.ten,i.password,moment(i.ngay_sinh).format("DD/MM/YYYY"),i.que_quan,i.comp_id,i.level+1,i.active,i.import_type]);
    }
    var ws = XLSX.utils.aoa_to_sheet(ws_data);
XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");
    var contents = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
    var blob = new Blob([s2ab(contents)], {type: "application/octet-stream"});
    FileSaver.saveAs(blob, "DSTS_"+moment().format('YYYYMMDDHHmmss')+".xlsx");
}
async exportExcelTemplate() {
  const { curLevelIndex,item } = this.state;
  var wb = XLSX.utils.book_new();
  wb.Props = {Title: "Danh sách thí sinh - "+item.comp_id};
        // wb.SheetNames.push("Sheet 1");
        // const ws = wb.Sheets["Sheet 1"];

        let ws_data = [["Mã cuộc thi","Tên","Tên đăng nhập","Mật khẩu","Ngày Sinh","Mã CS","SĐT","Email","Hình","Kích hoạt"]]


          ws_data.push([item.comp_id,"Nguyễn Quang Trình","TEST_TRINH","1234","21/01/2015","HQ","090909090","trinh@2u.com.vn","https://2u.com.vn/datafiles/banners/24-04-2017/14929674914710_logo.png","1"]);
          ws_data.push([item.comp_id,"Trần Duy Quang","","","21/04/2015","HQ","070707070","quang@2u.com.vn","","0"]);

    var ws = XLSX.utils.aoa_to_sheet(ws_data);
XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");
    var contents = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
    var blob = new Blob([s2ab(contents)], {type: "application/octet-stream"});
    FileSaver.saveAs(blob, "DSTS_Mau_"+item.comp_id+".xlsx");
}
  render() {
    const { classes, onClose, fullScreen, onChange, ...other } = this.props;
    const { item,csvData,downloadCSV,results,curLevelIndex,agentIndex,agents } = this.state;
    const agentList = [];
    for(let i of agents)
    {
      let a = {label:i.ten,value:i.machinhanh};
      agentList.push(a);
    }
let width=500;

    return (<div>
      {downloadCSV?this.showDownload(csvData):false}
      {!item ? '' :
        <Dialog onClose={this.props.onClose} open={false} fullScreen={fullScreen} {...other}>
          <DialogTitle>
            <Grid justify="flex-start" direction="row" container>
              <Grid item style={{ marginRight: 8 }}><AllInboxIcon /></Grid>
              <Grid item>
                <Typography variant="title" className={classes.title}></Typography>
              </Grid>
            </Grid>
          </DialogTitle>
          <DialogContent className={classes.container}>
            <Typography variant="title" color="primary" style={{ marginBottom: 10 }}>Danh sách thí sinh của {item.name}</Typography>

                  <Button style={{marginLeft:10}} onClick={()=>this.uploadRef.click()} variant="contained" color="secondary" size="medium">
                          Thêm từ excel
                      </Button>
                      <Button style={{marginLeft:10}} onClick={()=>this.loadListFromAPI()} variant="contained" color="secondary" size="medium">
                          {this.state.loading?<CircularProgress/>:"Thêm từ API"}
                      </Button>
                      <Button style={{marginLeft:10}} onClick={()=>this.exportExcelTemplate()} variant="contained" color="secondary" size="medium">
                              Tải file mẫu
                          </Button>
                          <Button style={{marginLeft:10}} onClick={()=>this.clearAll()} variant="contained" color="secondary" size="medium">
                                  Xoá tất cả thí sinh
                              </Button>

            <div>
              <Divider style={{marginTop:10,marginBottom:10}} />
                <FormControl style={{ marginBottom: 30 }} fullWidth>
                    <Input
                        value={this.state.search}
                        onChange={(e)=>this.setState({search:e.target.value})}
                        type="text"
                        placeholder="Tìm bởi tên hoặc tên đăng nhập"
                        className={classes.search}
                    />
                </FormControl>
                <Button onClick={()=>this.findItems()} variant="contained" color="secondary" size="medium">
                        Tìm
                    </Button>
                        <input style={{display:'none'}} ref={ref=>this.uploadRef = ref} type="file" accept=".xlsx, .xls, .csv" limit={1} name="file" onChange={(e)=>this.onUpload(e)} />

            </div>
            <Grid container style={{marginTop:20}}>
              <Grid   item style={{width:100,height:100,marginLeft:10,marginBottom:10}} >
                <Button onClick={e=>this.setState({curLevelIndex:-1},()=>this.loadResults())} style={{width:100,height:100,backgroundColor:curLevelIndex==-1?'#1B5E20':'grey',color:'white'}} size="large">
                  Tất cả
              </Button>
            </Grid>
              {item.levels.map((i, index) => {
                let current = curLevelIndex!=null?index==curLevelIndex:false;
                //console.log(current,i,curRoundIndex);
                let haveData = item.levels[curLevelIndex]?true:false;
                return (<Grid  key={index} item style={{width:100,height:100,marginLeft:10,marginBottom:10}} >
                  <Button onClick={e=>this.setState({curLevelIndex:index},()=>this.loadResults())} style={{width:100,height:100,backgroundColor:current?'#1B5E20':'grey',color:'white'}} size="large">
                    {i.name}
                </Button>
              </Grid>)})}
            </Grid>
            <Grid container>
              <Grid item >
                <TextField
                      value={_this.state.agentIndex}
                      onChange={(e)=>this.setState({agentIndex:e.target.value},()=>this.loadResults())}
                      label="Cơ sở"
                      placeholder=""
                      select
                      margin="normal"
                      InputLabelProps={{
                          shrink: true,
                          style: { color: '#1B5E20',fontSize:'1.2rem' }
                      }}
                      style={{width:width*0.3,marginLeft:10}}>
                      <MenuItem value={"All"}>
                        Tất cả
                      </MenuItem>
                      {agentList.map((t,index)=>{
                        return (<MenuItem key={"AgentItem"+index} value={t.value}>
                      {t.label}
                    </MenuItem>)
                      })}
                    </TextField>
                </Grid>
                <Grid item >
                <TextField
                      value={_this.state.import_type}
                      onChange={(e)=>this.setState({import_type:e.target.value},()=>this.loadResults())}
                      label="Đã thêm từ"
                      placeholder=""
                      select
                      margin="normal"
                      InputLabelProps={{
                          shrink: true,
                          style: { color: '#1B5E20',fontSize:'1.2rem' }
                      }}
                      style={{width:width*0.3,marginLeft:10}}>
                      <MenuItem value={"All"}>
                        Tất cả
                      </MenuItem>
                      {["API","Excel"].map((t,index)=>{
                        return (<MenuItem key={"Import"+index} value={t}>
                      {t}
                    </MenuItem>)
                      })}
                    </TextField>
                </Grid>
                </Grid>


            <Button onClick={()=>this.loadResults()} variant="contained" color="secondary" size="medium">
                    Xem danh sách
                </Button>
                <Divider style={{marginTop:10,marginBottom:10}} />
            <Grid container>
              <Grid item xs={12}>
                {results&&results.length>0&&<div>
                  Tổng: {results.length} <Button onClick={()=>this.exportExcel()} variant="contained" color="secondary" size="medium">
                          Export Excel
                      </Button>
              </div>}
            </Grid>
              <Grid item xs={12}>
                {results&&results.length>0&&<div className={classes.group_list}>
                      <div style={{display:'flex',flexDirection:'row'}}>
                        <div className={classes.group_list_item} style={{width:'15%'}}>Tên đăng nhập</div>
                        <div className={classes.group_list_item} style={{width:'20%'}}>Tên</div>
                        <div className={classes.group_list_item} style={{width:'10%'}}>Mật khẩu</div>
                        <div className={classes.group_list_item} style={{width:'10%'}}>Ngày sinh</div>
                        <div className={classes.group_list_item} style={{width:'15%'}}>Email</div>
                        <div className={classes.group_list_item} style={{width:'10%'}}>Cơ sở</div>
                        <div className={classes.group_list_item} style={{width:'8%'}}>Kích hoạt</div>
                        <div className={classes.group_list_item} style={{width:'5%'}}>Cấp độ</div>
                        <div className={classes.group_list_item} style={{width:'7%'}}></div>
                    </div>
                    {results.map((r,index)=>{

                      return <div key={index} style={{display:'flex',flexDirection:'row'}}>
                        <div className={classes.group_list_item} style={{width:'15%'}}>{r.username}</div>
                          <div className={classes.group_list_item} style={{width:'20%'}}><Avatar alt="" src={r.image} />{r.ten}</div>
                          <div className={classes.group_list_item} style={{width:'10%'}}>{r.password}</div>
                          <div className={classes.group_list_item} style={{width:'10%'}}>{moment(r.ngay_sinh).format("DD/MM/YYYY")}</div>
                            <div className={classes.group_list_item} style={{width:'15%'}}>{r.email}</div>
                            <div className={classes.group_list_item} style={{width:'10%'}}>{r.ten_cs}</div>
                        <div className={classes.group_list_item} style={{width:'8%'}}>

                            <TextField
                                value={r.active}
                                onChange={(e)=>this.onItemChange(e.target.value,r,'active')}
                                label=""
                                placeholder=""
                                select
                                margin="normal"
                                InputLabelProps={{
                                    shrink: true,
                                    style: { color: '#1B5E20',fontSize:'1.2rem' }
                                }}
                                fullWidth


                            >
                            {YesNoList.map((t,index)=>{
                              return (<MenuItem key={"LessItem"+index} value={t.value}>
                            {t.label}
                          </MenuItem>)
                            })}
                            </TextField></div>
                          <div className={classes.group_list_item} style={{width:'5%'}}>{item.levels[r.level]?item.levels[r.level].name:""}</div>

                          <div className={classes.group_list_item} style={{width:'7%'}}><Button onClick={()=>this.removeComp(r,index)} variant="contained" color="error" aria-label="add" size="small">Xoá
                    </Button></div>
                  </div>
                    })}

                  </div>}
              </Grid>
            </Grid>






          </DialogContent>

          <DialogActions style={{ padding: 10 }}>
            <Button onClick={this.handleClose()} size="large">
              <CloseIcon style={{ marginRight: 5 }} />BACK
          </Button>
          {/*!item.id ? '' : <Button onClick={this.DeleteItem(item.id)} size="large" color="primary">
              <DeleteIcon style={{ marginRight: 5 }} /> DELETE </Button>*/}

              {false&&<Button onClick={()=>this.export(item)}  size="large" variant="contained" color="secondary">
                Export
        </Button>}
          </DialogActions>
        </Dialog>
      }</div>);
  }
}

CreateDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  onClose: PropTypes.func
};

export default withStyles(styles)(CreateDialog);
